import uikitSdkLoader from '@uikit/sdk-loader'

/**
 * 显示企业分享4.0弹窗，kae开关未开启、未命中entry内策略时会抛出异常
 * @param {{
 *  fileId: string | number;
 *  source: void | Record<string, any>;
 *  position: string | void;
 *  shareEl: void | HTMLElement
 * }} theParam
 * @returns {Promise<*>}
 */
export async function showEntShare ({ fileId, source, position, shareEl } = {}) {
  if (window.performance && window.performance.mark) {
    performance.mark('KUC_SDK_DIVIDE_IN_CLOUD_ENTRY')
  }
  const sdk = await loadShareEntry()
  if (!sdk) {
    throw new Error('entry sdk load failed')
  }
  const isWiki = new URLSearchParams(window.location.search).get('source') === 'kmwiki'
  const from = 'mediaPreview' + (isWiki ? '-wiki' : '')
  const params = {
    fileId,
    source,
    position,
    from: from
  }
  if (shareEl) {
    return sdk.render(params, shareEl)
  }
  return sdk.dialog(params)
}

/**
 * 加载企业分享入口
 */
export function loadShareEntry () {
  return uikitSdkLoader('file-share-entry').load().catch(() => {})
}

if (typeof window !== 'undefined') {
  // 预加载企业 v4 分享
  loadShareEntry()
}
